<div>
  <div class="logo-container">
    <img src="assets/images/lychee-logo.png" alt="Lychee Logo">
  </div>
  <div class="invitation-card">
    <p>{{ 'store.invitation.greeting' | translate }}</p>
    <p>{{ 'store.invitation.body1' | translate }}</p>
    <p>{{ 'store.invitation.body2' | translate }}</p>
    <p>{{ 'store.invitation.cta' | translate }}</p>
    <div style="text-align: center">
      <button (click)="onAccept()">{{ 'store.invitation.accept' | translate }}</button>
    </div>
    <hr>
    <p>{{ 'store.invitation.thanks' | translate }}<br>{{ 'store.invitation.team' | translate }}</p>
  </div>
  <div class="copyright">{{ 'store.auth.rights' | translate }}</div>
</div>
